import { useEffect, useState } from 'react';

/**
 * Custom hook to detect if the device supports hover interactions.
 * Uses the CSS media query `(hover: hover)` to determine hover support.
 *
 * @returns {boolean} True if the device supports hover, false otherwise
 */
export const useSupportsHover = (): boolean => {
    const [supportsHover, setSupportsHover] = useState<boolean>(true);

    useEffect(() => {
        const mediaQuery = window.matchMedia('(hover: hover)');
        setSupportsHover(mediaQuery.matches);

        const handleChange = (e: MediaQueryListEvent): void => {
            setSupportsHover(e.matches);
        };

        mediaQuery.addEventListener('change', handleChange);
        return () => mediaQuery.removeEventListener('change', handleChange);
    }, []);

    return supportsHover;
};
